var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionWhiteArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 8.89992L12.8 14.8999C12.5 15.1999 12.1 15.3999 11.7 15.3999C11.4 15.3999 11 15.2999 10.7 14.9999C10.1 14.4999 9.99995 13.4999 10.5 12.8999L13.5 9.39992H2.19995C1.39995 9.39992 0.699951 8.69992 0.699951 7.89992C0.699951 7.09992 1.39995 6.39992 2.19995 6.39992H13.5L10.5 2.89992C9.99995 2.29992 9.99995 1.29992 10.7 0.799917C11.3 0.299917 12.3 0.299917 12.8 0.999917L17.9 6.99992C18.4 7.49992 18.4 8.29992 17.9 8.89992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionWhiteArrow);
export default __webpack_public_path__ + "static/media/action-white-arrow.e7a9538874bfc1459e99d39b85d7f3d1.svg";
export { ForwardRef as ReactComponent };